<template>
  <div class="email-step">
    <b-container>
      <b-row>
        <b-col>
          <div class="align-self-center text-center">
            <b-img
                class="logo"
                :src="logo.path"
                alt="Main Logo"
                v-if="!isBranded"
            />
            <h2 class="header-text">Disclosures done better.</h2>
            <p>We protect sellers agents and brokers from home sale mediations and lawsuits</p>
            <h5>Sign up or Sign in</h5>
            <p>Enter your email address to continue</p>
          </div>
        </b-col>
      </b-row>

      <b-form
          @submit.prevent="$emit('submit')"
      >
        <b-row>
          <b-col class="d-md-block"></b-col>
          <b-col cols="12" md="6">
            <b-form-group>
              <label for="email">Email <i class="far fa-circle-info"/></label>
              <b-input-group>
                <b-form-input
                    :disabled="loading || lockEmail"
                    :value="value.email"
                    @input="onEmailChange"
                    type="text"
                    :class="{'is-invalid': errors.length > 0}"
                />
              </b-input-group>
              <template v-if="errors.length">
                <b-form-invalid-feedback
                    :key="errIndex"
                    class="d-block"
                    v-for="(error, errIndex) in errors"
                >
                  {{ error }}
                </b-form-invalid-feedback>
              </template>
            </b-form-group>
          </b-col>
          <b-col class="d-md-block"></b-col>
        </b-row>

        <b-row>
          <b-col>
            <div class="align-self-center text-center">
              <p class="terms-and-conditions">
                By continuing, you agree to our
                <b-link
                    href="https://sellersshield.com/website-terms-of-use"
                    target="_blank"
                >
                  Terms of Use
                </b-link>
                and
                <b-link
                    href="https://sellersshield.com/privacy-policy"
                    target="_blank"
                >
                  Privacy Policy
                </b-link>
              </p>
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <b-form-group class="d-flex justify-content-center">
              <b-btn
                  pill
                  class="gold-button button-padding"
                  :disabled="isNextBtnDisabled || loading"
                  size="lg"
                  type="submit"
                  id="submit-button"
                  align-h="center"
              >
                Continue
              </b-btn>
            </b-form-group>
          </b-col>
        </b-row>



      </b-form>


    </b-container>



    </div>
</template>

<script>
import "./EmailStep.scss";


export default {
    name: 'EmailStep',
    props: {
        value: {
            type: Object,
            required: true,
            default: () => {
            }
        },
        errors: {
            type: Array,
            required: false,
            default: () => ([])
        },
        loading: {
            type: Boolean,
            required: false,
            default: false
        },
        lockEmail: {
            type: Boolean,
            required: false,
            default: false,
        },
        isBranded: {
            type: Boolean,
            required: false,
            default: false,
        }
    },
    data: () => ({
        logo: {
            path: require('@assets/images/ss-wordmark-black.png'),
        },
        background: {
            path: require('@assets/images/Rectangle1.png'),
        },
    }),
    computed: {
      isNextBtnDisabled() {
        return !this.value.email;
      }
    },
    methods: {
        onInput(value) {
            this.$emit('input', this.value);
        },
        onEmailChange(value) {
            this.value.email = value;
            this.onInput(value);
        }
    },
}
</script>
